import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from "react-icons/fa";
import styles from '../SubscriptionDowngrade.module.css';

const FaqSection = () => {
  const { t } = useTranslation();
  const [activeFaqIndex, setActiveFaqIndex] = useState(null);

  const faqs = [
    {
      question: t('subscription.faq.platform_question'),
      answer: t('subscription.faq.platform_answer')
    },
    {
      question: t('subscription.faq.downgrade_question'),
      answer: t('subscription.faq.downgrade_answer')
    },
    {
      question: t('subscription.faq.upgrade_question'),
      answer: t('subscription.faq.upgrade_answer')
    }
  ];

  const toggleFaq = (index) => {
    setActiveFaqIndex(activeFaqIndex === index ? null : index);
  };

  return (
    <div className={styles.faqSection}>
      <h2>{t('subscription.faq.title')}</h2>
      {faqs.map((faq, index) => (
        <div key={index} className={styles.faqItem}>
          <div 
            className={styles.faqQuestion} 
            onClick={() => toggleFaq(index)}
          >
            <span>{faq.question}</span>
            <span className={`${styles.arrowIcon} ${activeFaqIndex === index ? styles.rotate : ''}`}>
              <FaChevronDown />
            </span>
          </div>
          {activeFaqIndex === index && (
            <div className={styles.faqAnswer}>
              <p>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqSection; 